import {
    CButton,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPencil, cilTrash } from "@coreui/icons";
import React from "react";
import TableCaption from './TableCaption';
import TableFooterV2 from './TableFooterV2';
import styles from './Table.module.css';


const Table = ({
    columns,
    data,
    pagination,
    setFaqsPage,
    handleFaqSelected,
}) => {
    return (
        <>
            <div className="col-12">
            <TableCaption pagination={pagination} noun="preguntas frecuentes" />
            <div className={styles.tableCard}>
            <CTable responsive className={styles.styledTable}>
                <CTableHead>
                    <CTableRow>
                        {columns.map((col, index) => (
                            <CTableHeaderCell
                                key={index}
                                scope="col"
                                className={col._props.className}
                            >
                                {col.label}
                            </CTableHeaderCell>
                        ))}
                    </CTableRow>
                </CTableHead>
                <CTableBody>
                    {data.map((el, index) => (
                        <CTableRow key={index}>
                            <CTableDataCell>{el?.question}</CTableDataCell>
                            <CTableDataCell>{el?.answer}</CTableDataCell>
                            <CTableDataCell>
                                <div className="d-flex gap-2">
                                    <CButton
                                        color="primary"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => {
                                            handleFaqSelected(
                                                el.id,
                                                "edit"
                                            );
                                        }}
                                    >
                                        <CIcon icon={cilPencil} />
                                    </CButton>

                                    <CButton
                                        color="danger"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => {
                                            handleFaqSelected(
                                                el.id,
                                                "delete"
                                            );
                                        }}
                                    >
                                        <CIcon icon={cilTrash} />
                                    </CButton>
                                </div>
                            </CTableDataCell>
                        </CTableRow>
                    ))}
                </CTableBody>
            </CTable>
            {!data || data.length === 0 ? (
              <div className={styles.emptyState}>No se encontraron resultados.</div>
            ) : null}
            </div>
            </div>
            <TableFooterV2 range={pagination?.links} setPage={setFaqsPage} />
        </>
    );
};

export default Table;
